export default __webpack_public_path__ + "static/media/2.777637c4.jpg";